export default __webpack_public_path__ + "static/media/iconfinder_node-js_1269842.fbb6c18b.png";